import { useTheme } from '@mui/styles';

import {
  CELL_HEIGHT,
  CELL_SPACING,
  CELL_WIDTH,
  CUSTOM_HOLIDAY_PURPLE,
  CUSTOM_PADDING,
  DAY_GRAY,
  HOLIDAY_GREEN,
  MATERNITY_LEAVE_BLUE,
  MILITARY_REHEARSAL_BROWN,
  OTHER,
  PUBLIC_HOLIDAY,
  SICK_LEAVE_RED,
  STUDY_LEAVE_YELLOW,
} from '~/scenes/MyWorkspace/components/Widgets/components/MyTeamAbsencesWidget/constants';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    default: {
      width: `${CELL_WIDTH}px`,
      height: `${CELL_HEIGHT}px`,
      textAlign: 'center',
      borderRadius: `${theme.shape.borderRadius + 1}px`,
      display: 'inline-block',
      marginRight: `${CELL_SPACING}px`,
      backgroundColor: DAY_GRAY,
      flexShrink: 0,
      padding: `${CUSTOM_PADDING}px`,
    },
    holiday: {
      backgroundColor: HOLIDAY_GREEN,
    },
    militaryLeave: {
      backgroundColor: MILITARY_REHEARSAL_BROWN,
    },
    sickLeave: {
      backgroundColor: SICK_LEAVE_RED,
    },
    maternityLeave: {
      backgroundColor: MATERNITY_LEAVE_BLUE,
    },
    study: {
      backgroundColor: STUDY_LEAVE_YELLOW,
    },
    content: {
      color: 'white',
    },
    customHoliday: {
      backgroundColor: CUSTOM_HOLIDAY_PURPLE,
    },
    publicHoliday: {
      backgroundColor: PUBLIC_HOLIDAY,
    },
    other: {
      backgroundColor: OTHER,
    },
    endOfRange: {
      background: `repeating-linear-gradient(
        45deg,
        #696969,
        #808080 5px,
        #A9A9A9 5px,
        #C0C0C0 10px
      )`,
    },
  };
};
